import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";
import { Provider } from 'react-redux';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';
import config from './config';

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

const history = createBrowserHistory();
msalInstance.initialize().then(() => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <MemoryRouter basename={config.basename} history={history}>
          <App />
        </MemoryRouter>
      </Provider>
    </MsalProvider>
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
